import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes dudaba todo el tiempo… ahora tengo claro qué hacer en cada situación.',
  name: 'Camila R.',
  role: 'Buenos Aires'
}, {
  quote: 'Me dio seguridad en la práctica, sobre todo en guardias.',
  name: 'Florencia M.',
  role: 'Córdoba'
}, {
  quote: 'Dejé de sentir que estaba improvisando todo el tiempo.',
  name: 'Lucía G.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-276">
      <div className="max-w-xl mx-auto" data-id="element-277">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-278">
          💬 ¿Qué dicen las Enfermeras que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-279">
          {testimonials.map((t, i) => <div key={i} className="bg-white/5 backdrop-blur-sm border border-white/10 p-5 rounded-xl transition-all hover:bg-white/10" data-id="element-280">
              <div className="flex gap-0.5 mb-3" data-id="element-281">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-282" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-283">
                "{t.quote}"
              </p>
              <div data-id="element-284">
                <p className="font-bold text-white text-sm" data-id="element-285">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-286">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}